@if (showWebComponent) {
  <kit-dms-video
    [attr.dms_api]="dmsApi"
    [attr.dms_ids]="dmsIds">
  </kit-dms-video>
}
